<div class="ccm_usage">
    <div class="spinner-content" *ngIf="loading">
        <mat-spinner diameter="50"></mat-spinner>
    </div>
    <div class="ccm_usage_left" *ngIf="!loading">
        <h4>GLP-1 Usage</h4>
        <p [innerHTML]="dataInsight?.glp_text | safeHtml"></p>
        <ul>
            <li>Participants using GLP-1s</li>
            <li>Participants not using GLP-1s</li>
        </ul>
    </div>
    <div class="ccm_usage_ryt">
        <canvas id="glpPieChart" height="180" width="180"></canvas>
    </div>

</div>